import { render } from "./catalog.vue?vue&type=template&id=7c95fbbf"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"
script.render = render

export default script